module.exports = __webpack_public_path__ + "media/images/admin/node_builder_img/icons/buyoff-ef9e193c38161c1a4473607f941fb691.svg";